import React from 'react';
// import Swiper core and required modules
import SwiperCore, {
  Pagination
} from 'swiper';
import 'swiper/css';
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from 'swiper/react';
import './TextCarousel.scss';

// install Swiper modules
SwiperCore.use([Pagination]);

const TextCarousel = ({children}) => {
  let slides;
  if (Array.isArray(children)) {
    slides = children.map((slide, index) => {
      return <SwiperSlide key={index}>{slide}</SwiperSlide>
    })
  }

  return (
    <div className='TextCarousel'>
      <Swiper
        spaceBetween={30}
        slidesPerView={'auto'}
        centeredSlides={true}
        pagination={{
          "clickable": true}}
        className="mySwiper"
      >
        {slides}
      </Swiper>
    </div>
  )
}

export default TextCarousel